import { Box, Group, Text, Stack, HoverCard } from '@mantine/core'
import { useSetAtom } from 'jotai'
import { activeChatCharacterAtom } from '../../atoms/chatAtoms'
import { LipSyncPortrait } from '../common/LipSyncPortrait'
import { MarkdownRenderer } from '../common/MarkdownRenderer'
import { SectionLabel } from './SectionLabel'

// Character avatars. Beats have no single speaker, so we highlight every
// character who responded in the current character_response beat (none on other
// beat types). Tapping a member opens chat as a rail takeover. Hovering a member
// shows their public description (restored from the legacy Crew panel). Names
// always show in full — never truncated.
export function CastDock({ characters = [], activeCharacterIds = [] }) {
  const setActiveChat = useSetAtom(activeChatCharacterAtom)
  const activeSet = new Set(activeCharacterIds)
  if (!characters.length) return null

  return (
    <Box p="md" style={{ borderBottom: '1px solid var(--bw-panel-border)' }}>
      <SectionLabel>Cast</SectionLabel>
      <Group gap="sm" wrap="wrap" align="flex-start">
        {characters.map((c) => {
          const isActive = activeSet.has(c.id)
          const description = c.public_description || ''
          return (
            <HoverCard key={c.id} width={320} shadow="lg" position="top" openDelay={300} withArrow>
              <HoverCard.Target>
                <Stack gap={4} align="center" style={{ width: 72 }}>
                  <Box
                    className={`g2-cast-avatar${isActive ? ' is-active' : ''}`}
                    onClick={() => setActiveChat(c.id)}
                    role="button"
                    tabIndex={0}
                    aria-label={`Chat with ${c.name}`}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setActiveChat(c.id) }}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    <LipSyncPortrait character={c} size={46} active={isActive} square />
                  </Box>
                  <Text size="xs" ta="center" fw={isActive ? 700 : 400} style={{ width: '100%', lineHeight: 1.2 }}>
                    {c.name}
                  </Text>
                </Stack>
              </HoverCard.Target>
              <HoverCard.Dropdown
                style={{
                  background: 'rgba(10, 22, 40, 0.98)',
                  border: '1px solid rgba(0, 255, 255, 0.15)',
                  backdropFilter: 'blur(12px)',
                }}
              >
                <Text size="sm" fw={600} c="cyan.3" ff="var(--bw-heading-font)" mb="xs">
                  {c.name}
                </Text>
                {description ? (
                  <MarkdownRenderer
                    content={description}
                    style={{ fontSize: 'calc(0.75rem * var(--bw-content-scale, 1))', color: 'var(--mantine-color-gray-4)', lineHeight: 1.5 }}
                  />
                ) : (
                  <Text size="xs" c="dimmed" fs="italic">
                    No description available
                  </Text>
                )}
              </HoverCard.Dropdown>
            </HoverCard>
          )
        })}
      </Group>
    </Box>
  )
}
